import { FC, useMemo } from 'react';

import { AppHelmet } from '../../decorators/withHelmet';
import { makeBreadcrumbJsonLd } from '../../redux/selectors/catsSelector';
import { makeProductByIdSelector } from '../../redux/selectors/productById';
import { useSelector } from '../../redux/utils';
import { UserSubmitItem } from '../../types/UserSubmitItem';

interface Props {
  categoryId?: string;
  firstId?: string | number;
  title?: string;
  description?: string;
}

const Meta: FC<Props> = ({ categoryId, firstId, title, description }) => {
  const firstItem = useSelector<UserSubmitItem | undefined>(
    makeProductByIdSelector(`${firstId}`)
  );
  const jsonLd = useSelector(makeBreadcrumbJsonLd(categoryId || '0'));

  const ogImage = firstItem?.image_url;

  const meta = useMemo(() => {
    return {
      ogImage,
      jsonld: jsonLd,
      title,
      description,
      ogDescription: description,
    };
  }, [ogImage, jsonLd]);

  return <AppHelmet {...meta} />;
};

export default Meta;
